import * as React from 'react';
import { Theme } from '@mui/styles';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Button} from '@mui/material';
import { Typography } from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {Grid} from '@mui/material';
import * as request from 'superagent';
import URLManager from '~common/lib/url-manager';
import { setValueAtPath } from '~common/form/helper';
import DefinitionSection from '~common/form/definition-section';
import Renderers from '~common/lib/renderers';
import SelectableTable, { CellProps } from '~common/components/table/selectable-table';
import CloseIcon from '@mui/icons-material/Close';
import LoadingView from '~common/components/loading-view';
import { FormControlLabel, FormGroup, Checkbox } from '@mui/material';



  const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 490
    },
    MuiDialogContent: {
        paddingTop: 10,
        paddingRight: 5,
        width: 490
    },
    actionAutoConfirmButtonClass:{
        border: 'dashed 1px #dedede'
    },
    modalTitle: {
        padding: "0px 0px 20px 0px"
    },
    gridItem: {
        paddingBottom: "0px !important;",
        paddingTop: "0px !important;"
    },
    controlContainer: {
        width: "100%",
        padding: 0
    },
    dangerButton: {
        backgroundColor: "#af0202",
        '&:hover': {
            backgroundColor: "#5D0A0A !important"
        }
    },
    closeIcon:{
        // top: 25,
        // position:'absolute',
        // right:10,
        cursor: 'pointer',
        float: "right"
    }
})

interface Props extends React.HTMLProps<HTMLDivElement> {
    classes: any;
    open: boolean;
    action: any;
    task?: any;
    entity?: any;
    handleDispatch: (action: any, data: any)=>void;
    handleClose: ()=>void
}

type State = {
   open: boolean;
};


class PresentConfirmOnClose extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {
            open: true,
        }
      }

   componentDidMount() {

    }
    
    handleDispatch = (save: boolean) => {
        if (this.props.handleDispatch) {
            this.props.handleDispatch(this.props.action, {save: save})
        }
    }

    handleClose = () => {
        if (this.props.handleClose) {
            this.props.handleClose()
        }
    }

    static register = () => {
        if(!Renderers.find("PresentConfirmOnClose")){
          Renderers.register("PresentConfirmOnClose", withStyles(styles)(PresentConfirmOnClose))
        }
      }

      handleChange = (showWhat:string) => (event:any) => {
        this.state[showWhat] = !this.state[showWhat]
        this.setState({})
    }

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        const {open} = this.state
        const {action} = this.props
        const {dialogueOptions} = action

        return (
            <Dialog
                className={classes.modal}
                classes={{paper: classes.paper}}
                open={open}
                onClose={this.handleClose}
                disableBackdropClick={false}
            >   
                <DialogContent classes={{root: classes.MuiDialogContent}}>
                    <DialogTitle className={classes.modalTitle}>
                        Confirm {action.title}
                        <CloseIcon className={classes.closeIcon} onClick={this.handleClose} />
                    </DialogTitle>  

                    <Typography variant="body1">Are you sure you would like to Cancel and lose all your changes?</Typography> 

                </DialogContent>

                <DialogActions style={{justifyContent: "flex-start"}}>
                    <div style={{flex:1}}></div>
                    <Button 
                        variant="contained"
                        color="inherit"
                        onClick={this.handleClose}>
                        No
                    </Button>
                    {<Button 
                        autoFocus={true}
                        variant="contained"
                        color="primary"
                        onClick={this.handleDispatch.bind(this, false)}>
                        Yes
                    </Button>}
                </DialogActions>
    
            </Dialog>
        )
    }
}

export default withStyles(styles)(PresentConfirmOnClose);